/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from 'moment'
import React from 'react'
import { KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import { PDFLinkCard } from '../../../../_metronic/partials/content/cards/PDFLinkCard'
import { knowledgeModel } from '../../auth'
import { getPDFURL } from '../../auth/core/_api'

type Props = {
  item: knowledgeModel | undefined
}

const ItemDetail: React.FC<Props> = ({item}) => {
  return (
    <div className={`card`}>
      {/* begin::Body */}
      <div className='card-body pb-0'>
        {/* begin::Header */}
        <div className='d-flex align-items-center mb-3'>
          {/* begin::User */}
          <div className='d-flex align-items-center flex-grow-1'>
            {/* begin::Avatar */}
            {item?.pdf_file && item?.pdf_file != 'null' &&<div className='symbol symbol-45px me-5'>
               <PDFLinkCard icon='/media/svg/files/pdf.svg' title='' url={(item?.pdf_file)?getPDFURL(item?.pdf_file):"#"} />
            </div>}
            {/* end::Avatar */}
              
            {/* begin::Info */}
            <div className='d-flex flex-column'>
              {item?.title}
              <span className='text-gray-400 fw-semibold'>{item?.updated_at && moment(`${(item?.updated_at)}`).fromNow()}</span>
            </div>
            {/* end::Info */}
          </div>
          {/* end::User */}
        </div>
        {/* end::Header */}

        {/* begin::Post */}
        <div className='mb-7'>
          {/* begin::Text */}
          <div className='text-gray-800 mb-5'>
          {<div style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: `${item?.description}` }} />}
          </div>
          {/* end::Text */}
        </div>
        {/* end::Post */}

      </div>
      {/* end::Body */}
    </div>
  )
}

export {ItemDetail}
